import {
	type FetchSocialFeedMeByFeedSlugParams,
	type JSONwithRefsType,
	minutesToMs,
	resolveJSONrefs,
	socialApi
} from '@capsicum/common';
import { type FetchMeActivities, type PostActivityType } from '@capsicum/socios-core';
import { type QueryKey, useInfiniteQuery } from '@tanstack/react-query';

export const useSocialFeedMeQuery = (key: QueryKey, params: FetchSocialFeedMeByFeedSlugParams) => {
	const fetch = async (query: FetchSocialFeedMeByFeedSlugParams): Promise<FetchMeActivities<PostActivityType>> => {
		const api = await socialApi;
		const response = await resolveJSONrefs(
			(await api.fetchSocialFeedMeByFeedSlug(query)) as unknown as JSONwithRefsType
		);

		return response as FetchMeActivities<PostActivityType>;
	};

	const getActivityToDo = ({ pageParam = 0 }) => {
		const queryParams: FetchSocialFeedMeByFeedSlugParams = {
			...params,
			offset: pageParam
		};

		return fetch(queryParams);
	};

	const { data, error, fetchNextPage, hasNextPage, isFetched, isFetching, isLoading, refetch } = useInfiniteQuery({
		getNextPageParam: lastPage => {
			const nextOffset = lastPage?.metadata?.nextOffset;

			return nextOffset > 0 ? nextOffset : undefined;
		},
		initialPageParam: 0,
		queryFn: getActivityToDo,
		queryKey: key,
		retryOnMount: false,
		staleTime: minutesToMs(10)
	});

	return { data, error, fetchNextPage, hasNextPage, isFetched, isFetching, isLoading, refetch };
};
